import React from 'react'
import { ProjectStatus } from 'redux/types/project.type'
import { useTranslation } from 'react-i18next'

export const ProjectStatusCell: React.FC<{ status: ProjectStatus }> = React.memo(({ status }) => {
    const { t } = useTranslation()
    return <>{t(`projectStatus.${status}`)}</>
})
